<template>
  <div>
    <b-form @submit.prevent="clickSaveQuestion" class="m-0">
      <b-card
        class=""
        no-body
        :class="{ 'my-1': is_describe_yourself == 'false' }"
      >
        <b-card-body>
          <b-card-sub-title
            v-if="is_describe_yourself == 'true'"
            :class="{
              'subtitle-astrology-question': client_name == 'AV',
              'subtitle-mid-question': client_name == 'MID',
            }"
            >{{ question.question }}</b-card-sub-title
          >
          <div class="row" v-else>
            <div class="col-md-9">
              <b-form-group
                :label="'Question ' + (index + 1) + ' - ' + client_name"
                label-for="title"
                :title="question.question"
                :label-class="{
                  'form-label-astrology form-label-question-astrology':
                    client_name == 'AV',
                  'form-label-mid form-label-question-mid':
                    client_name == 'MID',
                }"
              >
                <b-form-textarea
                  id="title"
                  :class="{
                    'form-control-astrology': client_name == 'AV',
                    'form-control-mid': client_name == 'MID',
                  }"
                  v-model="question.question"
                  :title="question.question"
                  rows="3"
                  @change="onChangeTitle($event)"
                  >{{ question.question }}</b-form-textarea
                >
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-button
                variant="action"
                class="btn btn-bumblebee mb-1 delete-action"
                :class="{
                  'btn-astrology btn-delete-input-astrology':
                    client_name == 'AV',
                  'btn-mid btn-delete-input-mid': client_name == 'MID',
                }"
                @click="clickDeleteQuestion(question.id)"
              >
                Delete Question
              </b-button>
            </div>
          </div>
          <b-row>
            <b-col md="9">
              <b-form-group
                class="form-group-check"
                :class="{
                  'form-group-check-doomyoga': client_name == 'DY',
                  'form-group-check-mid': client_name == 'MID',
                  'form-group-check-astrology': client_name == 'AV',
                }"
                label="Type"
                v-slot="{ ariaDescribedby }"
                :label-class="{
                  'form-label-astrology form-label-question-astrology':
                    client_name == 'AV',
                  'form-label-mid form-label-question-mid':
                    client_name == 'MID',
                }"
              >
                <div class="row">
                  <div
                    class="col"
                    v-for="item in question_types"
                    :key="item.value"
                  >
                    <div class="form-check form-check-radio">
                      <label class="form-check-label">
                        <input
                          class="form-check-input"
                          type="radio"
                          :id="'type_' + item.value"
                          name="question_type"
                          v-model="question.type"
                          :value="item.value"
                          :aria-describedby="ariaDescribedby"
                          required
                        />
                        {{ item.label }}
                        <span class="circle">
                          <span class="check"></span>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <div id="questionsTextDiv" v-if="question.type == 'text'">
            <p
              class=""
              :class="{
                'question-options-label-astrology': client_name == 'AV',
                'question-options-label-mid': client_name == 'MID',
              }"
            >
              Open text reply
            </p>
          </div>
          <div id="questionOptionsDiv" v-else>
            <p
              :class="{
                'question-options-label-astrology': client_name == 'AV',
                'question-options-label-mid': client_name == 'MID',
              }"
            >
              Options:
            </p>
            <div class="row">
              <div class="col-md-9">
                <div
                  v-for="(option, index) in question.options"
                  :key="option.id"
                  :class="{
                    'question-option-astrology': client_name == 'AV',
                    'question-option-mid': client_name == 'MID',
                  }"
                >
                  <div class="row">
                    <div class="col-lg-5 col-md-5">
                      <div class="float-left">
                        <b-form-input
                          v-model="edit_option_value"
                          v-if="
                            (edit_option_id != null &&
                              edit_option_id == option.id) ||
                            (question.id == null && edit_option_index == index)
                          "
                        ></b-form-input>

                        <p class="value" v-else>{{ option.option }}</p>
                      </div>
                    </div>
                    <div class="col-lg-7 col-md-7">
                      <div
                        class="float-right questions-actions-mid"
                        v-if="
                          (edit_option_id != null &&
                            edit_option_id == option.id) ||
                          (question.id == null && edit_option_index == index)
                        "
                      >
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 delete-action ml-1"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="clickCancelOption(question.id, option.id)"
                        >
                          Cancel
                        </b-button>
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 edit-action"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="
                            clickConfirmEditOption(
                              question.id,
                              option.id,
                              index
                            )
                          "
                        >
                          Save
                        </b-button>
                      </div>
                      <div
                        class="float-right questions-actions-mid"
                        :class="{
                          'questions-actions-astrology': client_name == 'AV',
                          'questions-actions-mid': client_name == 'MID',
                        }"
                        v-else
                      >
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 delete-action ml-1"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="
                            clickDeleteOption(question.id, option.id, index)
                          "
                        >
                          Delete
                        </b-button>
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 edit-action"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="
                            clickEditOption(
                              question.id,
                              option.id,
                              option.option,
                              index
                            )
                          "
                        >
                          Edit
                        </b-button>
                      </div>
                      <div
                        v-if="question.type == 'audio'"
                        class="question-upload-audio-container"
                      >
                        <VueFileAgent
                          class="upload-audio-fileagent-astrology"
                          ref="vueFileAgent"
                          :theme="'list'"
                          :multiple="false"
                          :linkable="true"
                          :deletable="false"
                          :meta="false"
                          :helpText="'Choose images, videos or pdf files'"
                          :errorText="{
                            type: 'Invalid file type. Only images or zip Allowed',
                            size: 'Files should not exceed 10MB in size',
                          }"
                          @select="filesSelected($event, index)"
                          @beforedelete="onBeforeDelete($event, index)"
                          @delete="fileDeleted($event, index)"
                          v-model="option.audio"
                        >
                          <template v-slot:file-preview-new>
                            <div class="text-left" key="new">
                              <img
                                src="@/assets/images/astrology/upload-audio-icon.png"
                                alt="ads icon"
                                class="question-upload-astrology"
                              />
                            </div>
                          </template>
                        </VueFileAgent>
                      </div>
                      <div
                        v-if="question.type == 'audio' && option.audio != null"
                        class="float-right"
                      >
                        <button
                          type="button"
                          @click="deleteAudio(index)"
                          class="btn-question-delete-astrology"
                        >
                          <img
                            src="@/assets/images/astrology/delete-audio-icon.png"
                            alt="delete icon"
                          />
                        </button>
                        <button
                          v-if="option.audio != null && option.audio.id != null"
                          type="button"
                          @click="playAudio(index)"
                          :id="'playAudioBtn-' + option.id"
                          class="btn-question-play-astrology"
                        >
                          <img
                            src="@/assets/images/astrology/play-icon.png"
                            alt="play icon"
                          />
                        </button>
                        <button
                          v-if="option.audio != null && option.audio.id != null"
                          type="button"
                          @click="pauseAudio(index)"
                          :id="'pauseAudioBtn-' + option.id"
                          class="btn-question-play-astrology"
                          style="display: none"
                        >
                          <img
                            src="@/assets/images/astrology/pause-icon.png"
                            alt="pause icon"
                          />
                        </button>
                      </div>
                      <div
                        v-if="question.type == 'audio' && option.audio != null"
                        class="float-right"
                      >
                        <audio
                          controls
                          :id="'audio-' + option.id"
                          class="question-option-audio-av"
                          v-if="option.audio != null && option.audio.id != null"
                          style="display: none"
                        >
                          <source :src="option.audio.path" type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="question-option-mid add-option-mid"
                  :class="{
                    'question-option-astrology add-option-astrology':
                      client_name == 'AV',
                    'question-option-mid add-option-mid': client_name == 'MID',
                  }"
                >
                  <div class="row">
                    <div class="col-lg-7 col-md-6">
                      <div class="float-left">
                        <!-- <p class="add-new">Add new</p> -->
                        <b-form-input
                          v-model="new_option_value"
                          v-if="is_add_option == true"
                        ></b-form-input>

                        <b-button
                          v-else
                          variant="action"
                          class="btn btn-bumblebee mb-1 add-action"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="clickAddOption(question.id)"
                        >
                          Add new option
                        </b-button>
                      </div>
                    </div>

                    <div class="col-lg-5 col-md-6">
                      <div
                        class="float-right"
                        :class="{
                          ' questions-actions-astrology': client_name == 'AV',
                          ' questions-actions-mid': client_name == 'MID',
                        }"
                        v-if="is_add_option == true"
                      >
                        <!-- <p class="save-action">Save</p> -->
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 delete-action ml-1"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="clickCancelAddOption"
                        >
                          Cancel
                        </b-button>
                        <b-button
                          variant="action"
                          class="btn btn-bumblebee mb-1 save-action"
                          :class="{
                            'btn-astrology btn-edit-input-astrology':
                              client_name == 'AV',
                            'btn-mid btn-edit-input-mid': client_name == 'MID',
                          }"
                          @click="clickSaveNewOption(question.id)"
                        >
                          Save
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="is_describe_yourself == 'false'">
            <div class="col-md-3 offset-md-9">
              <b-button
                type="submit"
                variant="bumblebee"
                class="btn float-right"
                :class="{
                  'btn-astrology btn-astrology-primary btn-astrology-submit':
                    client_name == 'AV',
                  'btn-mid btn-mid-primary btn-mid-submit':
                    client_name == 'MID',
                }"
                v-if="!is_loading"
              >
                Save changes
              </b-button>
              <b-button
                type="button"
                disabled
                variant="bumblebee"
                class="btn float-right"
                :class="{
                  'btn-astrology btn-astrology-primary btn-astrology-submit':
                    client_name == 'AV',
                  'btn-mid btn-mid-primary btn-mid-submit':
                    client_name == 'MID',
                }"
                v-else
              >
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="light"
                ></b-spinner>
                Loading
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-form>
    <!-- delete modal -->
    <b-modal
      id="deleteModal"
      centered
      :modal-class="
        client_name == 'AV' ? 'modal-astrology' : 'modal-irish-date'
      "
    >
      <div class="d-block mb-4">
        <!-- <input id="event_id" name="event_id" type="hidden" v-model="event_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" /> -->
        <p
          class="confirmMessageModalP my-4"
          v-bind:class="{
            'message-modal-dy': client_name == 'DY',
            'message-modal-av': client_name == 'AV',
            'message-modal-mid': client_name == 'MID',
          }"
        >
          Are you sure to delete this {{ item_name }}?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-danger' : 'astrology-danger'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-astrology  btn-astrology-submit': client_name == 'AV',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="clickConfirmDelete"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID'
                  ? 'mid-secondary-outline'
                  : 'astrology-secondary-outline'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-astrology btn-astrology-submit': client_name == 'AV',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="closeModalDelete"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- end delete modal-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
  name: "SingleQuestion",
  props: [
    "client_name",
    "is_describe_yourself",
    "question",
    "index",
    "question_types",
  ],
  components: {},
  data() {
    return {
      selected_option_id: null,
      item_name: "item",
      item_index: null,
      edit_option_id: null,
      edit_option_value: null,
      edit_option_index: null,
      is_add_option: false,
      new_option_value: null,
      is_loading: false,
      option_audio: null,
      // question_type: null,
    };
  },
  /**:question_id="row.id"
                        :title.sync="row.question"
                        :options.sync="row.options"
                        :index="rowIndex"
                        :question_type.sync="row.type" */
  mounted() {
    console.log(this.question);
    console.log(
      this.question.id,
      this.question.question,
      this.question.options,
      this.index,
      this.question.type,
      this.client_name
    );

    // if (this.client_name == "AV" && this.question.id != null) {
    //   for (let j = 0; j < this.question.options.length; j++) {
    //     this.question.options[j].audio = {
    //       path:
    //         "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-" +
    //         (j + 1) +
    //         ".mp3",
    //     };
    //   }
    // if(this.client_name == 'AV' ){
    //   for(let i=0; i<this.questions.length; i++){
    //     if(this.questions[i].type == 'audio'){
    //
    //     }
    //   }
    // }
    // }
    console.log(this.question.options);

    // console.log(this.title, " --- ", this.question);
    // this.question = this.title;
    // this.question_type = this.type;
    // console.log(this.question_type, this.type)
  },
  updated() {
    console.log(this.question);
    this.$emit("update:question", this.question);
    // console.log(this.title, " === ", this.question);
    // this.question = this.title;
    // if (this.is_describe_yourself == "false") {
    //   this.$parent.$parent.$parent.$parent.questions[this.index].title = this.title;
    // }
  },
  computed: {
    // _title: {
    //   get() {
    //     return this.title;
    //   },
    //   set(value) {
    //     // console.log(value);
    //     this.$emit("update:title", value);
    //   },
    // },
    // _question_type: {
    //   get() {
    //     return this.question_type;
    //   },
    //   set(value) {
    //     //console.log(this.question_type, value);
    //     if (
    //       (this.question_type == "onechoice" ||
    //         this.question_type == "multichoice") &&
    //       value == "text"
    //     ) {
    //       this.$emit("update:options", []);
    //     }
    //     this.$emit("update:question_type", value);
    //     // this.question.options =[]
    //   },
    // },
    // options:{
    //   get(){
    //     return this.question.options
    //   },
    //   set(value){
    //     this.$emit("update:options",value)
    //   }
    // }
  },
  watch: {
    question: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  methods: {
    clickSaveQuestion() {
      // console.log("click save changes " + this.question_id + " " + this.title);
      // console.log(this.question.options);
      this.is_loading = true;
      if (this.question.id == null) {
        // new question
        // console.log(this.title);
        // console.log(this.question_type);
        // console.log(this.question.options);
        this.sendAddQuestionRequest();
      } else {
        // console.log("before call edit request ", this.question_id);
        this.sendUpdateQuestionsRequest();
      }
    },
    sendAddQuestionRequest() {
      // console.log("in send add question request ");
      // console.log(this.question.options);
      // console.log(this.question_type);

      // let formData = new FormData();
      // formData.append("client", this.client_name);
      // formData.append("question", this.title);
      // formData.append("type", this.question_type);
      // formData.append("options[]", this.question.options);

      // this.question.options.forEach((element,i) => {
      //   console.log(element, i);
      //   console.log((element));
      //   formData.append("options["+i+"]", (element));
      // });
      let requestData = {
        client: this.client_name,
        question: this.question.question,
        type: this.question.type,
        options: this.question.options,
      };
      axios
        .post("social/admin/questions", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Question is created successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          // this.$router.go();

          this.$parent.$parent.$parent.$parent.getQuestionsList();
        })
        .catch((error) => {
          // console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendUpdateQuestionsRequest() {
      // console.log("in send update question request ");
      // console.log(this.question.options);
      // console.log(this.question_type);
      // console.log(this.question_id);

      // let formData = new FormData();
      // formData.append("client", this.client_name);
      // formData.append("question", this.title);
      // formData.append("type", this.question_type);
      // formData.append("options[]", this.question.options);

      // this.question.options.forEach((element,i) => {
      //   console.log(element, i);
      //   console.log((element));
      //   formData.append("options["+i+"]", (element));
      // });
      let requestData = {
        client: this.client_name,
        question: this.question.question,
        type: this.question.type,
        options: this.question.options,
        _method: "put",
      };
      // console.log(this.question_id)
      axios
        .post("social/admin/questions/" + this.question.id, requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(response);
          this.$fire({
            // title: "Title",
            text: "Question is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          // this.$router.go();

          this.$parent.$parent.$parent.$parent.getQuestionsList();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    // delete question
    clickDeleteQuestion(question_id) {
      // console.log("confirm delete question " + question_id + " " + this.index);
      this.item_name = "question";
      // this.item_index = index;
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    clickConfirmDelete() {
      // let formData = new FormData();
      // formData.append("event_id", $("#deleteModal #event_id").val());
      // let eventId = $("#deleteModal #event_id").val();
      // let client = $("#deleteModal #client").val();

      console.log(
        "delete ",
        this.item_name,
        ",",
        this.question.id,
        ",",
        this.selected_option_id,
        ",",
        this.item_index,
        ",",
        this.index
      );

      if (
        this.is_describe_yourself == "false" &&
        this.question.id == null &&
        this.item_name == "question"
      ) {
        this.$parent.$parent.$parent.$parent.questions.splice(this.index, 1);
        this.$bvModal.hide("deleteModal");
        // console.log(this.$parent.$parent.$parent.$parent.questions);
      }
      if (
        this.is_describe_yourself == "false" &&
        this.question.id == null &&
        this.item_name == "option"
      ) {
        // this.$bvModal.hide("deleteModal");
        // this.$parent.$parent.$parent.$parent.questions[this.index].options.splice(
        //   this.item_index,
        //   1
        // );
        // this.question.options.splice(this.item_index, 1);
        // console.log(this.$parent.$parent.$parent.$parent.questions);
      }
      // return;
      if (this.question.id != null && this.item_name == "question") {
        this.sendRequestDeleteQuestion();
      } else if (this.item_name == "option") {
        // console.log("before delete option ");
        // console.log("option index ", this.option_index, this.item_index);
        this.question.options.splice(this.item_index, 1);
        this.$bvModal.hide("deleteModal");
        // console.log(this.$parent.$parent.$parent.$parent.questions);
      }
    },
    sendRequestDeleteQuestion() {
      axios
        .delete("social/admin/questions/" + this.question.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(response);
          this.$bvModal.hide("deleteModal");
          this.$fire({
            // title: "Title",
            text: "Question is deleted successfully.",
            type: "success",
            timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.$parent.$parent.$parent.$parent.getQuestionsList();
          // this.$parent.getEventsList();
          // this.$router.go();
          // this.events = response.data.events;
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteModal");
    },
    //////

    clickDeleteOption(questions_id, option_id, option_index) {
      // console.log(
      //   "delete option " +
      //     questions_id +
      //     " " +
      //     option_id +
      //     " " +
      //     this.index +
      //     " " +
      //     option_index
      // );

      this.selected_option_id = option_id;
      this.item_name = "option";
      this.item_index = option_index;
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    clickEditOption(question_id, option_id, option_name, index) {
      // console.log(
      //   "edit option " +
      //     question_id +
      //     " " +
      //     option_id +
      //     " " +
      //     option_name +
      //     " , " +
      //     this.index +
      //     " , " +
      //     index
      // );

      this.edit_option_id = option_id;
      this.edit_option_value = option_name;
      this.edit_option_index = index;
    },
    clickCancelOption(questions_id, option_id) {
      // console.log("cancel option " + questions_id + " " + option_id);

      this.edit_option_id = null;
      this.edit_option_value = null;
      this.edit_option_index = null;
    },

    clickAddOption(question_id) {
      // console.log("click add option ", question_id);
      this.is_add_option = true;
    },

    clickSaveNewOption(question_id) {
      // console.log("click save new option ", question_id, this.new_option_value);
      //if (question_id == null && this.is_describe_yourself == "false") {
      // this.$parent.$parent.$parent.$parent.questions[this.index].options.push({
      //   option: this.new_option_value,
      // });
      this.question.options.push({
        option: this.new_option_value,
        audio: null,
      });

      // console.log(this.$parent.$parent.$parent.$parent.questions);
      //}
      this.is_add_option = false;
      this.new_option_value = null;
    },
    clickCancelAddOption() {
      // console.log("click cancel new option ");
      this.is_add_option = false;
      this.new_option_value = null;
    },
    clickConfirmEditOption(question_id, option_id, index) {
      // console.log(
      //   "click confirm edit option ",
      //   question_id,
      //   option_id,
      //   this.edit_option_value,
      //   this.edit_option_id,
      //   index,
      //   this.index
      // );
      // console.log(question_id == null, this.is_describe_yourself == "false");

      // if (question_id == null && this.is_describe_yourself == "false") {
      //   // this.$parent.$parent.$parent.$parent.questions[this.index].options[index].option =
      //   this.edit_option_value;
      this.question.options[index].option = this.edit_option_value;
      //}
      this.edit_option_id = null;
      this.edit_option_value = null;
      this.edit_option_index = null;
    },
    ////////// file agent functions
    uploadFiles: function () {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
      // this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function (fileRecordsNewlySelected, index) {
      console.log(fileRecordsNewlySelected, index);
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      console.log(validFileRecords);
      // this.option_audio = validFileRecords;
      console.log(this.question.options);
      this.question.options[index].audio = validFileRecords;
      this.question = Object.assign({}, this.question);
      this.$emit("update:question", this.question);
      console.log(this.question.options);
    },
    onBeforeDelete: function (fileRecord, index) {
      console.log(index);
      this.option_audio = null;
    },
    fileDeleted: function (fileRecord, index) {
      console.log(index);
      this.option_audio = null;
    },
    deleteAudio(index) {
      console.log("delete audio ", index);
      this.question.options[index].audio = null;
      console.log(this.question.options);
      console.log(this.question);
      // this.$emit("update:question", this.question);
      // this.$parent.$parent.$parent.$parent.questions[this.index].options = this.question.options
      this.question = Object.assign({}, this.question);
      this.$emit("update:question", this.question);
    },
    playAudio(index) {
      console.log(
        "play audio ",
        index,
        this.question.options[index].audio.path,
        this.question.options[index].id
      );
      // const audio = new Audio(this.question.options[index].audio.path);
      // audio.play();
      $("#audio-" + this.question.options[index].id).css("display", "block");
      var audio = document.getElementById(
        "audio-" + this.question.options[index].id
      );
      audio.play();
      $("#playAudioBtn-" + this.question.options[index].id).css(
        "display",
        "none"
      );
      $("#pauseAudioBtn-" + this.question.options[index].id).css(
        "display",
        "inline-block"
      );
    },
    pauseAudio(index) {
      console.log(
        "pause audio ",
        index,
        this.question.options[index].audio.path,
        this.question.options[index].id
      );
      // const audio = new Audio(this.question.options[index].audio.path);
      // audio.play();

      var audio = document.getElementById(
        "audio-" + this.question.options[index].id
      );
      audio.pause();
      $("#audio-" + this.question.options[index].id).css("display", "none");
      $("#playAudioBtn-" + this.question.options[index].id).css(
        "display",
        "inline-block"
      );
      $("#pauseAudioBtn-" + this.question.options[index].id).css(
        "display",
        "none"
      );
    },
  },
};
</script>
<style >
.form-group label.form-label-mid.form-label-question-mid {
  font-weight: 600;
}
.form-group label.form-label-astrology.form-label-question-astrology {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/questionnaire/SingleQuestion.vue